export default __webpack_public_path__ + "static/media/imagetwo.8d84aec2.gif";